import { VyFormSection, VyIcon, VyChip, VyTypography, VyStack } from '@vy/ui-design-system';
import { useChargeContext } from '../../charge-context';
import { VySwitchField } from '../../../../../../design-system-adapters/forms';
import { FieldGrid } from '../../modify-panel-shared/layout';
import {
  UPLIFT_UNAVAILABLE_DESCRIPTION,
  useIsUpliftAvailable,
} from '../../modify-panel-shared/hooks/use-is-uplift-available';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';

export function UpgradeOptionsSection() {
  const { itemIndex: productIndex } = useChargeContext();
  const isUpliftAvailable = useIsUpliftAvailable();

  return (
    <VyFormSection
      icon={<VyIcon icon="SectionUpgrade" width={20} height={20} />}
      title="Upgrade Options"
      action={
        <VyStack direction="row" sx={{ gap: 1, alignItems: 'center' }}>
          <VyChip label="Growth" color="success" />
          <VyTypography variant="caption" color="text.secondary">
            Configure upgrade paths for this product
          </VyTypography>
        </VyStack>
      }
    >
      <FieldGrid>
        <VySwitchField<PlanInputForm>
          name={`fixedProducts.${productIndex}.upliftConfiguration.seatUpliftEnabled`}
          title="Unit / Seats Ramp up"
          description={
            isUpliftAvailable
              ? "Seats will increase annually based on the previous period's usage"
              : UPLIFT_UNAVAILABLE_DESCRIPTION
          }
          disabled={!isUpliftAvailable}
          data-field-span="full"
          data-vy="plan-charge-drawer-seats-ramp-switch"
        />
        {/* TODO: render Upgrade Path/Trigger/Threshold/Effective + Auto-upgrade/Notify controls once they exist on FixedProductInput. */}
      </FieldGrid>
    </VyFormSection>
  );
}
